import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaCheckCircle, FaHeadset, FaLightbulb, FaChartLine } from 'react-icons/fa';
import './WhyChooseUs.css';
import { motion } from 'framer-motion';
import { staggerContainer, item, fadeInUp } from '../../styles/animations';

const WhyChooseUs = () => {
  const reasons = [
    {
      icon: <FaCheckCircle />,
      title: "Quality Assurance",
      description: "We maintain the highest standards of quality in all our services and solutions."
    },
    {
      icon: <FaHeadset />,
      title: "24/7 Support",
      description: "Our dedicated team is available round the clock to address your concerns and queries."
    },
    {
      icon: <FaLightbulb />,
      title: "Innovative Solutions",
      description: "We leverage cutting-edge technologies to deliver innovative solutions tailored to your needs."
    },
    {
      icon: <FaChartLine />,
      title: "Proven Results",
      description: "Our track record speaks for itself with consistent growth and client satisfaction."
    }
  ];

  return (
    <section className="why-choose-us-section">
      <Container>
        <motion.div className="section-heading text-center" variants={fadeInUp} initial="hidden" whileInView="visible" viewport={{ once: true }}>
      <span className="subtitle">Why Choose Us</span>
          <h2>Reasons to Partner with Lyros Technologies</h2>
          <p className="section-description">
            We deliver strategic talent solutions, not just resumes. Our extensive network and personalized approach ensure you connect with exceptional professionals who are the perfect fit for your team.
          </p>
        </motion.div>

        <motion.div className="row g-4" variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{ once: true }}>
          {reasons.map((reason, index) => (
            <Col md={6} lg={3} key={index}>
              <motion.div className="reason-card" variants={item} whileHover={{ scale: 1.03 }}>
                <div className="reason-icon">
                  {reason.icon}
                </div>
                <h3 className="reason-title">{reason.title}</h3>
                <p className="reason-description">{reason.description}</p>
              </motion.div>
            </Col>
          ))}
        </motion.div>
        
   {  /*   <motion.div className="cta-container text-center" variants={fadeInUp} initial="hidden" whileInView="visible" viewport={{ once: true }}>
          <a href="contact" className="btn btn-primary btn-lg">Get Started Today</a>
        </motion.div>*/}
      </Container>
    </section>
  );
};

export default WhyChooseUs;